import { render } from "./ThirdInnerCard.vue?vue&type=template&id=064b3c11&scoped=true"
import script from "./ThirdInnerCard.vue?vue&type=script&lang=js"
export * from "./ThirdInnerCard.vue?vue&type=script&lang=js"

import "./ThirdInnerCard.vue?vue&type=style&index=0&id=064b3c11&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/air8-client-web(ali-prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064b3c11"]])

export default __exports__